// extracted by mini-css-extract-plugin
export default {"notification":"not_not_1KwnZ","expanded":"not_exp_2DHon","card":"not_car_2hvo4","wrapper":"not_wra_1-pWZ"};